<script setup>

import Header from './header.vue'
import Content from './content.vue'
// import Footer from '@/components/common/web-footer.vue'
import { onMounted } from 'vue'
// import { addShareNum } from '@/api/2025/index.js'
import { URLparams } from '@/utils/help.js'

const id = URLparams.get('secret')

onMounted (() => {
    // if(id){
    //     addShareNum(id)
    // }
    //整体缩放
    let resizeWindow = function (){
        let root = document.getElementById("app");
        if(window.innerWidth<1480){
            let fangdabili = window.innerWidth / 1480;
            root.style.transformOrigin = `0 0`       
            root.style.transform = `scale(${fangdabili})`       
            root.style.width = `${100/fangdabili}vw`      
            // root.style.padding = `${180/fangdabili}px 0 0`  
            root.style.height = `${100/fangdabili}vh`       
        }else{
            root.style.transformOrigin = ``       
            root.style.transform = ``       
            root.style.width = ``       
            root.style.height = `` 
        }
    }
    resizeWindow()
    window.addEventListener("resize",()=>{
        resizeWindow()
    })
})

</script>
<template>
    <div class="topicRecriuit">
        <a-back-top />
        <Header />
        <Content />
        <!-- <Footer /> -->
    </div>
</template>
<style lang="scss" scoped>
.topicRecriuit{
    width: 100%;
    min-width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: rgb(249, 250, 251);
}
</style>
